import React from 'react';
import { T, card, definitionRow } from './accountStyles';

const labelStyle = {
  width: 180,
  flexShrink: 0,
  fontSize: 12,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  color: T.textFaint,
};

const valueStyle = { fontSize: 16, fontWeight: 500, color: T.textPrimary };

// Profile section: identity + a (currently dummy) password reset affordance.
// The real change-password flow isn't wired yet, so "Reset password" is an
// inert placeholder link until that endpoint exists.
export default function ProfileCard({ user }) {
  const username = user?.username || '—';
  const email = user?.email || '—';

  return (
    <div style={{ ...card, padding: '30px 32px', maxWidth: 640 }}>
      <h2 style={{ fontFamily: T.serif, fontSize: 23, fontWeight: 600, color: T.textHeading, margin: '0 0 6px' }}>
        Profile
      </h2>

      <div style={{ ...definitionRow, borderTop: 'none' }}>
        <span style={labelStyle}>Username</span>
        <span style={valueStyle}>{username}</span>
      </div>
      <div style={definitionRow}>
        <span style={labelStyle}>Email address</span>
        <span style={valueStyle}>{email}</span>
      </div>
      {/* Password / reset-password row hidden for now — re-enable once the
          change-password flow is implemented. */}
    </div>
  );
}
